import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { ChevronLeft } from "../../icons/ChevronLeft";
import { SearchMd } from "../../icons/SearchMd";
// import { Tabs } from "./Filters/Tabs";
import { BookmarkForHeader } from "../../icons/BookmarkForHearder";
import NewFilter from "./Filters/NewFilter";
import { commonFetchData, dispatchEventToParent, getLocalStorageData, setLocalStorageData, updateQueryParams } from "../../utils/commanFunctions";
import SearchInput from "./SearchComponents/SearchInput";
import { Height } from "@material-ui/icons";
import logo from "../../commonImages/logo.svg"
import HeartForHeader from "../../icons/HeartForHeader";
import { Link } from "react-router-dom";
import { trackExit } from "../../utils/FunctionsForGa";

const LS_FILTER_KEY = "header_filter";
const LS_SEARCH_QUERY_KEY = "header_search_query";

const getInitialFilter = (key=LS_FILTER_KEY) => {

  return {
    "display_value": "All",
    "query_value": "all"
  };

  const savedFilter = localStorage.getItem(key);
  if (savedFilter) {
    try {
      return JSON.parse(savedFilter);
    } catch (e) {
      console.error("Error parsing saved filter", e);
    }
  }
  return {
    "display_value": "All",
    "query_value": "all"
  };
};





export const Header = ({intialFetch=true,data={},url=null,setData,setNoData,setIsLoading,filterType="live",parentClass,additionStyle,myPosition="",showFilter=true,showSearch=true,showBookMark=true,showBack=true}) => {




  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // const getLSKey = (key=LS_FILTER_KEY)=>{
  //   const searchParams = new URLSearchParams(location.search);
  //   const path = searchParams.get('path')
  //   console.log(path, "path");
    
  //   const map = {
  //     'trip':"explore",
  //     "":"explore",
  //     [path]:path
  //   }
  //   return `${key}_${map[path] || "explore"}`;
  // }

  const getLSKey = (key = LS_FILTER_KEY) => {
    try {
      const searchParams = new URLSearchParams(location.search);
      const path = searchParams.get('path') || '';
      // console.log(path, "path");
      
      
      const suffix = path === 'trip' || path === '' ? 'explore' : path;
      
      const validSuffix = suffix || 'explore';
      
      const sanitizedKey = key.replace(/[^a-zA-Z0-9_-]/g, '');
      const sanitizedSuffix = validSuffix.replace(/[^a-zA-Z0-9_-]/g, '');
      
      return `${sanitizedKey}_${sanitizedSuffix}`;
    } catch (error) {
      console.error('Error generating LS key:', error);
      return `${key}_explore`;
    }
  };

  const [selectedFilter, setSelectedFilter] = useState(getInitialFilter(getLSKey()));
    const inputRef = useRef(null);
    const fullFilterData = useRef([])
    const [q, setQ] = useState(() => {
      return ""
      // return localStorage.getItem(getLSKey(LS_SEARCH_QUERY_KEY)) || "";
    });
    
    // const filter = searchParams.get('filter')
    const apiParams = searchParams.get('apiParams') || localStorage.getItem('apiParams') 


    const navigate = useNavigate()

    useEffect(() => {
      if (q && inputRef.current) {
        inputRef.current.value = q;
      }
      
    }, [q]);

    // useEffect(() => {
    //   localStorage.setItem(getLSKey(), JSON.stringify(selectedFilter));
    // }, [selectedFilter]);


      // useEffect(() => {
      //   if (q !== null) {
      //     localStorage.setItem(getLSKey(LS_SEARCH_QUERY_KEY), q);
      //   }
      // }, [q]);


    // useEffect(() => {
    //   if (filter && filter.includes("+")) {
    //     const [display_value,query_value] = filter.split("+")
    //     setSelectedFilter({
    //       display_value,query_value
    //     })
    //     // if(selectedFilterRef)
    //     //   selectedFilterRef.current = {
    //     //     display_value,query_value
    //     //   }
    //   }
    //   // else
    //   // if(selectedFilterRef)
    //   //   selectedFilterRef.current = selectedFilter
      
    // }, [filter]);

    const goBack = (e)=>{
        e?.stopPropagation()  
        // console.log(data.goBackToParent,"goBackToParent:window.GoBackToParent");      
        // if(data.eventType){
        //   const eventData = {
        //     type: data.eventType,
        //     data: data.eventData,
        //   };
      
        //   window.top.postMessage(eventData, '*');
        // }
        // else
        // navigate(-1)
// console.log(window.history.length,window.history);
const selectedTab = localStorage.getItem("selectedTab");

trackExit({tab: selectedTab})
        if(window.history.state && window.history.state?.key){
          navigate(-1)
        }
        else {
          const eventData = {
                type:  "INNSPIRE_GO_HOME",
                payload: {},
              };
          
             dispatchEventToParent(eventData)
        }

        // if(data?.goBackToParent)
        //   data.goBackToParent()
        // else
        // navigate(-1)
    }



  //         const fetchData = React.useCallback(
  //             async (e, d) => {
  //               e?.stopPropagation();
  //               if (d) {
  //   setSelectedFilter({ ...d }); // force new object ref
  // }
    
  //               const text = inputRef.current?.value?.trim() || '';
                
  //               // if (!d?.query_value || d.query_value === selectedFilter?.query_value) return;
            
  //               const isLiveFilter = filterType === "live";
  //               let newData = [];
  //               let query_key = fullFilterData[0]?.query_key || "category"
  //               const filterKey = d?.query_value ? d.query_value : selectedFilter.query_value

  //               // console.log(filterKey,"ddddddddddddddd");
                
  //               // console.log(d,newData);
            
  //               setIsLoading?.(true);
            
  //               try {
  //                 if (isLiveFilter) {
  //                   const defUrl = `/planner/places-events/groups/`;
  //                   let dynUrl = url || defUrl;

  //                   if(filterKey)
  //                     dynUrl+=`${dynUrl.includes("?")?"&":"?"}${query_key}=${filterKey}`
  //                   if(text)
  //                        dynUrl+=`${dynUrl.includes("?")?"&":"?"}${"q"}=${encodeURIComponent(text)}`
  //                     if(dynUrl.includes("/planner/places-events/groups/") && !(dynUrl.includes("id=") || dynUrl.includes("id_")))
  //                        dynUrl+=`${dynUrl.includes("?")?"&":"?"}${"apiParams"}=${apiParams}`
            
  //                   console.log(dynUrl);
            
  //                   newData = await commonFetchData(dynUrl, { req: "get", onErrorData: [] });
  //                 } else {
  //                   const { allPlaceAndEvent = [] } = getLocalStorageData("appData", {});
            
  //                   newData = !d || d?.query_value === "all" 
  //                     ? allPlaceAndEvent 
  //                     : allPlaceAndEvent.filter((item) => item.display_category?.value === d.query_value);

                      
  //                 }
            
  //                 setData(newData);
  //                 setNoData?.(newData.length === 0);
  //                 // if(d || selectedFilter){
  //                 //   const k = d || selectedFilter
  //                 //   if(d)
  //                 //   setSelectedFilter(d);
  //                 //   // localStorage.setItem(getLSKey(), JSON.stringify(k));
  //                 // }
                 
  //                 if (text || text === "") {
  //                   setQ(text);
  //           // localStorage.setItem(getLSKey(LS_SEARCH_QUERY_KEY), text);
  //                 }

                    
  //               } catch (error) {
  //                 console.error("Filter change error:", error);
  //                 setNoData?.(true);
  //               } finally {
  //                 setIsLoading?.(false);
  //               }
  //             },
  //             [selectedFilter, filterType, url, setIsLoading, setNoData, setData, apiParams]
  //           );

const fetchIdRef = useRef(0);

const fetchData = React.useCallback(
  async (e, d) => {
    e?.stopPropagation();

    const currentFetchId = ++fetchIdRef.current; // increment fetch ID
    if (d) {
      setSelectedFilter({ ...d }); // update selected filter
      localStorage.setItem("selectedFilter", JSON.stringify(d?.query_value))
    }

    const text = inputRef.current?.value?.trim() || '';
    const isLiveFilter = filterType === "live";
    let newData = [];
    let query_key = fullFilterData[0]?.query_key || "category";
    const filterKey = d?.query_value ? d.query_value : selectedFilter.query_value;

    setIsLoading?.(true);

    try {
      if (isLiveFilter) {
        const defUrl = `/planner/places-events/groups/`;
        let dynUrl = url || defUrl;

        if (filterKey)
          dynUrl += `${dynUrl.includes("?") ? "&" : "?"}${query_key}=${filterKey}`;
        if (text)
          dynUrl += `${dynUrl.includes("?") ? "&" : "?"}q=${encodeURIComponent(text)}`;
        if (
          dynUrl.includes("/planner/places-events/groups/") &&
          !(dynUrl.includes("id=") || dynUrl.includes("id_"))
        )
          dynUrl += `${dynUrl.includes("?") ? "&" : "?"}apiParams=${apiParams}`;

        newData = await commonFetchData(dynUrl, {
          req: "get",
          onErrorData: [],
        });
      } else {
        const { allPlaceAndEvent = [] } = getLocalStorageData("appData", {});
        newData =
          !d || d?.query_value === "all"
            ? allPlaceAndEvent
            : allPlaceAndEvent.filter(
                (item) => item.display_category?.value === d.query_value
              );
      }

      // Only update data if it's the latest request
      if (fetchIdRef.current === currentFetchId) {
        setData(newData);
        setNoData?.(newData.length === 0);
        if (text || text === "") setQ(text);
      }
    } catch (error) {
      console.error("Filter change error:", error);
      if (fetchIdRef.current === currentFetchId) {
        setNoData?.(true);
      }
    } finally {
      if (fetchIdRef.current === currentFetchId) {
        setIsLoading?.(false);
      }
    }
  },
  [selectedFilter, filterType, url, setIsLoading, setNoData, setData, apiParams]
);

            useEffect(()=>{              
              if(intialFetch)
              fetchData(null,selectedFilter)
            },[])

  return (
  
    <div className={`flex flex-col w-full items-start ${myPosition || "fixed"} top-0 left-0 bg-white z-10 test`}>

       <div className="flex h-[40px] items-center justify-center p-2 relative my-1 w-[100%] title-and-controls">
     <div
             style={{
              ...(!showBack? {
                visibility:"hidden"
              }:{})
            }}
     className="flex items-center gap-1 relative flex-1 grow mt-[-3.50px] mb-[-3.50px]  ">
       <div className="inline-flex items-center gap-2 p-2 relative flex-[0_0_auto] title-and-controls-col1">

         <div onClick={goBack} className="relative w-fit font-normal text-wwwstanfordcourtcomthunder text-base tracking-[0] leading-[normal] whitespace-nowrap flex items-center gap-[2px]">
         <ChevronLeft className="!relative cursor-pointer !w-6 !h-6 header-back-icon" />
         <div className="header-back-text cursor-pointer text-[#F8F8F8] text-[14px] leading-[20px] font-light mt-[2px]">Back</div>
         </div>
       </div>
     </div>

     <Link to={"/"} className="h-9 center-heading header-title-box">
      <img src={logo} alt="logo" className="cursor-pointer logo" />
     <div className="header-title font-normal  text-2xl text-center tracking-[0] leading-8 whitespace-nowrap header">
      {data.title}
     </div>
   </Link>

    
        <div 
        style={{
          ...(!showBookMark? {
            visibility:"hidden"
          }:{})
        }}
        onClick={(e)=>{
      e?.stopPropagation()
     if(data.buttonUrl) navigate(data.buttonUrl)
     else
     navigate(updateQueryParams({path:"myFavorites"}))
     
     }} className="flex items-center justify-end gap-0.5 relative flex-1 grow title-and-controls-col3">
  <div className="mt-[-1.00px] relative w-fit font-secondary font-normal text-wwwstanfordcourtcomthunder text-base tracking-[0] leading-[normal] whitespace-nowrap">
    {data.buttonText ||  <HeartForHeader className="!relative header-bookmark !w-6 !h-6" />}
   
  </div>
</div>
    
   </div>     

     {
      showSearch &&  <SearchInput q={q} inputRef={inputRef} fetchData={fetchData} setQ={setQ}/>
     }

        {
          
          showFilter && <NewFilter url={url} filterHandler={fetchData} fullFilterData={fullFilterData} selectedFilter={selectedFilter}/> 
        }
    </div>
  );
};